var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _rect2, _rect3, _rect4, _circle, _circle2, _circle3, _path30, _rect5, _rect6, _rect7, _circle4, _circle5, _circle6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeroResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 294 181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100.417,
    y: 36.365,
    width: 73.289,
    height: 55.393,
    rx: 6.818,
    fill: "#EAEAF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.786 26.013a2.982 2.982 0 0 1-2.723 3.221c-2.337.197-4.724.658-7.62 1.495a2.983 2.983 0 1 1-1.656-5.731c3.189-.922 5.97-1.472 8.777-1.708a2.983 2.983 0 0 1 3.222 2.723Zm6.579.506a2.983 2.983 0 0 1 3.341-2.576c1.876.243 3.939.535 6.232.859l2.088.294a2.983 2.983 0 0 1-.831 5.908l-2.117-.299c-2.284-.323-4.299-.608-6.138-.846a2.982 2.982 0 0 1-2.575-3.34Zm20.732 2.815a2.982 2.982 0 0 1 3.32-2.602c1.326.161 2.71.324 4.156.488a2.983 2.983 0 0 1-.673 5.928c-1.462-.166-2.86-.331-4.201-.494a2.983 2.983 0 0 1-2.602-3.32Zm-47.528 1.624a2.983 2.983 0 0 1-1.692 3.864c-1.223.478-2.517.991-3.891 1.541-1.07.428-2.076.933-3.026 1.509a2.983 2.983 0 0 1-3.093-5.1 26.482 26.482 0 0 1 3.903-1.948 549.276 549.276 0 0 1 3.935-1.558 2.983 2.983 0 0 1 3.864 1.692Zm-16.728 9.918a2.984 2.984 0 0 1 .715 4.157c-1.331 1.883-2.537 3.984-3.659 6.267a2.982 2.982 0 1 1-5.354-2.63c1.226-2.497 2.588-4.882 4.141-7.08a2.982 2.982 0 0 1 4.157-.714Zm-9.028 17.036a2.983 2.983 0 0 1 1.81 3.81 348.474 348.474 0 0 0-2.468 7.263 2.982 2.982 0 1 1-5.664-1.873 351.863 351.863 0 0 1 2.512-7.39 2.983 2.983 0 0 1 3.81-1.81Zm-6.209 18.324a2.982 2.982 0 0 1 1.781 3.823 120.608 120.608 0 0 1-2.937 7.374 2.983 2.983 0 0 1-5.458-2.407c.992-2.25 1.911-4.597 2.79-7.01a2.983 2.983 0 0 1 3.824-1.78Zm-7.746 17.71a2.982 2.982 0 0 1 .739 4.153c-1.598 2.292-3.393 4.428-5.438 6.336a2.982 2.982 0 1 1-4.069-4.362c1.693-1.58 3.219-3.386 4.615-5.387a2.983 2.983 0 0 1 4.153-.74ZM97.127 107.29a2.982 2.982 0 0 1-1.761 3.833c-1.298.481-2.653.89-4.07 1.222-1.407.33-2.735.638-3.99.925a2.983 2.983 0 0 1-1.328-5.816c1.241-.283 2.558-.589 3.956-.917a28.22 28.22 0 0 0 3.36-1.007 2.982 2.982 0 0 1 3.833 1.76Zm-49.018 1.373a2.982 2.982 0 0 1 3.657-2.101c1.488.402 2.805.786 3.991 1.146a2.982 2.982 0 1 1-1.733 5.708 124.04 124.04 0 0 0-3.814-1.095 2.984 2.984 0 0 1-2.101-3.658Zm29.566 3.666a2.983 2.983 0 0 1-2.455 3.43c-3.577.591-6.282.819-8.698.704a2.983 2.983 0 0 1 .283-5.959c1.83.087 4.074-.074 7.441-.631a2.983 2.983 0 0 1 3.43 2.456Z",
    fill: "#F3F3F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.727 97.297c15.766 4.26 12.017 6.477 39.628 0 34.514-8.096 25.566-64.767 53.262-75.846 27.697-11.079 23.862-7.67 61.359-3.41",
    stroke: "#D6C9E8",
    strokeWidth: 5.965,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "8.52 12.78"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M214.026 162.323a4.015 4.015 0 0 1-.834 1.706c-.194.214-.388.369-.62.582l-.679.465-.291.117c-.445.155-.93.155-1.376 0a3.363 3.363 0 0 1-.465-.252l-.136-.097a.66.66 0 0 1-.31-.194 10.899 10.899 0 0 1-1.629-2.268 99.815 99.815 0 0 1-4.187-9.461 85.974 85.974 0 0 0-5.816-12.039 18.73 18.73 0 0 1-2.889-11.632c.601-8.646 7.018-15.877 13.978-16.109a7.742 7.742 0 0 1 3.664.62 4.342 4.342 0 0 1 2.113 2.287c.817 2.232.939 4.658.349 6.96a38.024 38.024 0 0 1-1.357 5.816 95.71 95.71 0 0 1-1.842 5.816c-.252.659-.465 1.357-.737 2.055a18.704 18.704 0 0 0-.988 6.455 45.92 45.92 0 0 0 3.315 12.795c.366 1.048.67 2.116.911 3.199 0 .31 0 .64.136.911a5.417 5.417 0 0 1-.31 2.268Z",
    fill: "#F5F5FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M213.25 165.056a.645.645 0 0 1-.232.232.837.837 0 0 1-1.144-.232c-9.054-14.036-10.1-34.004-5.37-43.154a.803.803 0 0 1 .475-.417.808.808 0 0 1 .63.049.852.852 0 0 1 .368 1.124c-4.517 8.724-3.218 28.343 5.273 41.487a.811.811 0 0 1 0 .911Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M269.376 165.965c-4.368-.306-8.867-.896-13.497-1.529a31.232 31.232 0 0 0-18.193 3.472c-10.199 4.914-17.931 12.558-24.155 9.151a.875.875 0 0 1-.48-.327 2.433 2.433 0 0 1-.699-.459 3.111 3.111 0 0 1-.59-.612 1.594 1.594 0 0 1-.349-.327 3.344 3.344 0 0 1-.787-2.184 2.342 2.342 0 0 1 .197-1.07 4.588 4.588 0 0 1 1.026-1.835 17.33 17.33 0 0 1 2.752-2.861c3.167-2.708 7.95-5.744 13.235-9.326a202.66 202.66 0 0 0 3.888-2.708c2.795-1.965 5.678-4.106 8.474-6.399 1.638-1.354 3.276-2.752 4.826-4.237a31.038 31.038 0 0 1 17.472-8.408c13.825-1.769 27.344 6.006 30.008 16.926 3.08 12.208-8.19 13.934-23.128 12.733Z",
    fill: "#E1E1EC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M278.898 154.524c-.05.167-.133.324-.243.46a1.329 1.329 0 0 1-1.417.435 20.734 20.734 0 0 0-2.883-.633c-8.932-1.485-21.621.524-34.07 5.503a84.075 84.075 0 0 0-25.509 15.616c-.371.306-.699.655-1.048.983-.35.327-.131.131-.175.174l-.24.219a.35.35 0 0 1-.175.109 1.404 1.404 0 0 1-1.267.175 1.718 1.718 0 0 1-.437-.35c-.2-.21-.329-.477-.371-.764a.882.882 0 0 1 0-.415 1.92 1.92 0 0 1 .35-.655c.24-.262.524-.503.764-.721.24-.218.786-.764 1.267-1.136a18.473 18.473 0 0 1 2.184-1.922 78.457 78.457 0 0 1 12.427-8.561 93.829 93.829 0 0 1 12.426-5.787c12.536-4.827 25.16-6.552 34.267-5.089 1.067.177 2.124.41 3.167.699a1.377 1.377 0 0 1 .983 1.66Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M200.558 171.818c.285.424.591.832.918 1.223.396.455.827.878 1.288 1.267a.768.768 0 0 0 .328.24l.131.131c.161.12.328.229.502.328.448.392.93.743 1.442 1.048 5.372 3.298 14.196 4.499 26.207-3.123a15.904 15.904 0 0 0 2.796-2.315 19.655 19.655 0 0 0 4.368-7.906c.335-1.076.613-2.17.83-3.276a70.986 70.986 0 0 0 1.354-9.129c.437-4.171.721-8.408 1.332-12.449 1.048-6.988 2.992-13.104 7.928-17.122 18.455-14.633 9.085-38.154 1.616-50.407-7.469-12.252-6.181 6.552-23.565 20.311-10.199 7.972-11.881 18.128-11.488 27.781 0 2.642.284 5.263.502 7.709.11 1.092.263 2.053.284 3.08.342 2.687.488 5.394.437 8.102 0 5.176-5.045 9.217-9.981 13.235a167.799 167.799 0 0 0-4.368 3.626 28.688 28.688 0 0 1-1.878 1.812 17.226 17.226 0 0 0-2.861 3.975c-1.747 3.495-1.66 7.251 1.878 11.859Z",
    fill: "#F5F5FA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M200.557 171.82c.285.423.591.831.917 1.223.397.455.828.878 1.289 1.267.135-.053.274-.097.415-.131a3.97 3.97 0 0 0 .786-.219 3.032 3.032 0 0 0 1.005-.196l1.791-.502c.524-.11 1.135-.372 1.703-.525a43.523 43.523 0 0 0 16.074-9.369 28.408 28.408 0 0 0 5.548-7.622 24.921 24.921 0 0 0 1.769-4.608 158.185 158.185 0 0 0 3.538-19.35c.393-2.774.764-5.679 1.245-8.584 1.965-12.23 5.023-25.006 12.842-34.725a1.493 1.493 0 0 0-2.337-1.856c-7.339 9.041-10.549 20.376-12.624 31.646-.873 4.368-1.485 8.736-2.184 13.104a170.041 170.041 0 0 1-3.472 18.957 22.161 22.161 0 0 1-3.713 7.622 35.848 35.848 0 0 1-16.096 11.335c-1.223.393-2.359.808-3.364 1.157l-1.79.459c-.328 0-.546.175-.743.131-.617.188-1.244.341-1.878.458a.428.428 0 0 0-.219 0 .922.922 0 0 0-.502.328Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m197.218 59.286.427 2.268a45.61 45.61 0 0 0 6.882-1.822l-.756-2.191a43.602 43.602 0 0 1-6.553 1.745ZM111.492 126.828a4.949 4.949 0 0 0-.524-.116l.407-.155.117.271Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M158.717 35.403v40.381c.009.451-.044.9-.155 1.338a5.466 5.466 0 0 1-5.273 4.11H95.286a5.428 5.428 0 0 1-5.428-5.448V35.403a5.428 5.428 0 0 1 5.428-5.428h58.003a5.449 5.449 0 0 1 5.428 5.428Z",
    fill: "#061067"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M164.532 31.291v40.44a5.45 5.45 0 0 1-5.447 5.448H101.1a5.447 5.447 0 0 1-5.447-5.448v-40.44a4.808 4.808 0 0 1 .174-1.318 5.447 5.447 0 0 1 5.273-4.11h57.985a5.448 5.448 0 0 1 5.447 5.428Z",
    fill: "#BC35A1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.832 32.705H94.723a3.199 3.199 0 0 0-3.199 3.199v39.431a3.199 3.199 0 0 0 3.2 3.2h59.108a3.2 3.2 0 0 0 3.199-3.2V35.904a3.2 3.2 0 0 0-3.199-3.199Z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.022 35.148h-8.51a1.861 1.861 0 0 0 0 3.723h8.51a1.86 1.86 0 1 0 0-3.723ZM114.09 43.406H99.492a1.842 1.842 0 0 0-1.842 1.842v27.664c0 1.017.825 1.842 1.842 1.842h14.598a1.842 1.842 0 0 0 1.842-1.842V45.248a1.842 1.842 0 0 0-1.842-1.842ZM152.242 64.79v5.68a4.282 4.282 0 0 1-4.284 4.284H124.19a4.283 4.283 0 0 1-4.284-4.284v-5.68c7.328-10.178 8.82-7.58 12.077-4.595 3.257 2.986 5.952-3.354 9.325-6.34 3.373-2.985 5.215 2.715 7.755 5.235a10.918 10.918 0 0 1 3.179 5.7Z",
    fill: "#AF5CF6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M152.242 66.883v3.587a4.282 4.282 0 0 1-4.284 4.284H124.19a4.283 4.283 0 0 1-4.284-4.284v-3.276a6.571 6.571 0 0 1 8.685-.194c3.063 2.908 5.04 3.47 10.72-1.493 5.39-4.653 7.503-3.916 12.931 1.376Z",
    fill: "#E799D8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M123.201 43.406h-2.5a.795.795 0 0 0-.795.795v2.5c0 .44.356.796.795.796h2.5a.795.795 0 0 0 .795-.795v-2.5a.795.795 0 0 0-.795-.796ZM129.289 43.406h-2.501a.795.795 0 0 0-.795.795v2.5c0 .44.356.796.795.796h2.501a.795.795 0 0 0 .795-.795v-2.5a.795.795 0 0 0-.795-.796ZM135.376 43.406h-2.501a.795.795 0 0 0-.795.795v2.5c0 .44.356.796.795.796h2.501a.795.795 0 0 0 .795-.795v-2.5a.795.795 0 0 0-.795-.796Z",
    fill: "#F8ACC0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M164.533 31.29v40.44a5.45 5.45 0 0 1-5.447 5.447h-.524a5.466 5.466 0 0 1-5.273 4.11H95.286a5.428 5.428 0 0 1-5.428-5.448v-21.5l1.667-.736a42.627 42.627 0 0 1 4.129-1.55 25.376 25.376 0 0 1 11.632-1.3c5.001.718 9.499 3.315 13.9 5.816 1.318.737 2.636 1.493 3.993 2.171a27.687 27.687 0 0 0 10.023 3.18 13.027 13.027 0 0 0 12-5.215c.254-.38.474-.783.659-1.202 2.501-5.68-1.144-12.116-1.299-18.359-.041-1.499.176-2.994.64-4.42a15.88 15.88 0 0 1 1.124-2.733 19.033 19.033 0 0 1 2.695-4.11h8.065a5.445 5.445 0 0 1 5.447 5.409Z",
    fill: "url(#a)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M163.098 55.892c5.544 6.514 15.896 16.13 19.386 17.952 0 0 23.864 9.13 23.263 5.06l.853-7.192-21.324-4.634-20.414-14.094-1.764 2.908Z",
    fill: "#FDE3EA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M207.318 180.157c3.234 0 5.855-.26 5.855-.581 0-.321-2.621-.582-5.855-.582-3.233 0-5.854.261-5.854.582 0 .321 2.621.581 5.854.581Z",
    fill: "#000"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M186.498 76.033c4.032 3.18 14.908 6.495 18.553 5.952l4.749-9.422-20.22-5.118c-2.21 2.695-2.132 6.398-3.082 8.588Z",
    fill: "#981F7F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m211.797 175.99-3.878-32.549c1.144-10.042 4.033-27.141 4.033-35.729l-14.967-1.939c-2.442 6.417-1.609 26.986-.116 36.543 1.493 8.434 11.477 34.489 11.477 34.489l3.451-.815Z",
    fill: "#3538BC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m188.145 177.29 1.415-35.942c8.103-12.621 10.042-26.055 10.953-34.469l-14.268.368s-7.445 17.642-7.561 28.033c-.485 8.549 2.094 24.213 5.545 42.223l3.916-.213Z",
    fill: "#3538BC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M212.281 109.864c-9.364 2.482-20.104 2.889-27.664 0 4.633-7.231.659-22.643-2.346-35.05 7.91-4.517 23.981-6.805 27.625-2.268 3.936 7.773 3.49 22.856 2.385 37.318Z",
    fill: "#BC35A1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M158.678 82.568c6.882 7.192 17.215 15.043 22.74 12.891a12.157 12.157 0 0 0 4.129-3.315c3.315-3.877 6.727-8.355 6.126-12.446l-9.422-4.807-3.412 12.523-.329 1.24-18.301-8.374-1.531 2.288ZM199.719 70.084c-1.105 1.628-5.816 2.151-8.104 1.24a6.898 6.898 0 0 0 .756-5.816l4.924-.194a6.833 6.833 0 0 0 2.424 4.77Z",
    fill: "#FDE3EA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M199.564 65.274c-.756 1.764-8.433 3.16-9.557 1.24-1.765-4.807-.446-11.631 1.706-13.977l9.693.679-1.842 12.058Z",
    fill: "#FDE3EA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M194 58.743a4.923 4.923 0 0 1-5.273-.66c-2.52-2.132-3.412-8.394 0-8.587a3.703 3.703 0 0 1 4.11 2.287s6.223-2.636 8.821 0a5.29 5.29 0 0 1 1.454 5.525 7.408 7.408 0 0 1 1.745 4.75c0 3.063-3.257 5.7-4.692 4.982a3.872 3.872 0 0 1-2.829 1.49 3.876 3.876 0 0 1-2.987-1.14 2.137 2.137 0 0 1 .014-2.437c.167-.237.38-.437.626-.588 1.822-1.338 2.792-1.163 2.462-2.85-.33-1.687-1.939-.407-2.733 1.124-.795 1.532-1.803 0-1.803 0L194 58.743ZM188.203 175.739a3.236 3.236 0 0 1 .117 4.245l-11.884.175c-1.396-1.473 4.75-1.357 7.386-4.866a4.898 4.898 0 0 0 4.381.446ZM211.234 171.686a3.26 3.26 0 0 1 1.454 3.974l-11.225 3.877c-1.803-.95 4.052-2.792 5.467-6.921a4.986 4.986 0 0 0 4.304-.93Z",
    fill: "#061067"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M160.191 80.337c.135-2.578-.698-3.722-.95-2.598-.252 1.125-1.125 1.59-2.094-.523-.969-2.113-2.869-.66-2.404 1.609.465 2.268 3.877 3.722 3.877 3.722l1.571-2.21Z",
    fill: "#FDE3EA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M178.355 87.589c2.229 2.966 3.877 5.466 6.087 6.61 3.315-3.76 8.201-10.313 7.6-14.404l-9.79-4.904-3.897 12.698Z",
    fill: "#BC35A1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M166.122 78.225a1.086 1.086 0 0 1-1.202 1.066h-9.848a2.806 2.806 0 0 1-2.327-1.57l-.872-2.172-3.877-9.693a1.357 1.357 0 0 1 0-.911 1.065 1.065 0 0 1 1.163-.756h9.809a2.792 2.792 0 0 1 2.424 1.667l.446 1.105 4.284 10.74c.036.173.036.351 0 .524Z",
    fill: "#AF5CF6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M153.347 67.873h-1.338a1.379 1.379 0 0 1-1.163-.795.544.544 0 0 1 .524-.795h1.357a1.32 1.32 0 0 1 1.143.795.518.518 0 0 1-.006.565.52.52 0 0 1-.517.23ZM162.439 75.88h-6.979a1.706 1.706 0 0 1-1.493-1.027l-1.589-3.877a.705.705 0 0 1 .031-.717.7.7 0 0 1 .647-.31h6.863a1.767 1.767 0 0 1 1.512 1.027l1.59 3.877a.67.67 0 0 1 .096.34.674.674 0 0 1-.678.687Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M166.123 78.225a1.087 1.087 0 0 1-1.202 1.067h-9.849a2.814 2.814 0 0 1-2.326-1.57l-.872-2.172a10.29 10.29 0 0 0 1.938-1.163c.325-.277.618-.589.873-.93a3.414 3.414 0 0 0 .543-3.296 1.959 1.959 0 0 0-.097-.194 4.58 4.58 0 0 0-2.501-1.939h-.233l-1.221-.426a7.74 7.74 0 0 1-1.667-.795 5.112 5.112 0 0 1-1.532-1.745 1.069 1.069 0 0 1 1.163-.756h9.81a2.793 2.793 0 0 1 2.423 1.667l.446 1.105a7.214 7.214 0 0 0-.504 3.645c.159.79.497 1.532.988 2.171.815 1.202 1.939 2.21 2.85 3.393.422.592.749 1.246.97 1.938Z",
    fill: "url(#b)"
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M164.94 52.984a6.729 6.729 0 0 0-4.226-4.711c-1.939-1.008-2.269-1.764-2.637-.989-.368.776 1.609 2.327 2.365 3.277.756.95-.872 2.268-.116 3.76a3.571 3.571 0 0 0 2.772 1.57l1.842-2.907Z",
    fill: "#FDE3EA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.21 83.237h2.422a2.13 2.13 0 0 1 0 4.26h-2.815a5.111 5.111 0 0 1-4.429 2.558 5.111 5.111 0 0 1-4.429-2.557H5.396a2.13 2.13 0 1 1 0-4.261h21.17a5.116 5.116 0 0 1 9.644 0ZM8.38 90.907a5.116 5.116 0 0 1 4.822 3.409h25.43a2.13 2.13 0 0 1 0 4.26H12.809a5.115 5.115 0 0 1-9.406-1.38 2.126 2.126 0 0 1-.13-.917 5.113 5.113 0 0 1 5.107-5.372Zm-2.983 14.487a2.13 2.13 0 0 0 0 4.261H19.29a5.112 5.112 0 0 0 8.858 0h10.485a2.13 2.13 0 0 0 0-4.261H28.54a5.115 5.115 0 0 0-9.645 0h-13.5Z",
    fill: "#E9E9F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.709,
    y: 79.828,
    width: 37.497,
    height: 4.261,
    rx: 2.131,
    fill: "#C23AA9"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    fill: "url(#c)",
    d: "M.709 79.828h37.497v4.261H.709z"
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.709,
    y: 90.906,
    width: 37.497,
    height: 4.261,
    rx: 2.131,
    fill: "#C23AA9"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    fill: "url(#d)",
    d: "M.709 90.906h37.497v4.261H.709z"
  }), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.709,
    y: 101.984,
    width: 37.497,
    height: 4.261,
    rx: 2.131,
    fill: "#C23AA9"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    fill: "url(#e)",
    d: "M.709 101.984h37.497v4.261H.709z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.162,
    cy: 103.689,
    r: 5.113,
    fill: "#CE45BA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.822,
    cy: 92.611,
    r: 5.113,
    fill: "#CE45BA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.831,
    cy: 81.533,
    r: 5.113,
    fill: "#CE45BA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.492 7.391h10.486a2.13 2.13 0 0 1 0 4.261h-10.879a5.112 5.112 0 0 1-4.429 2.557 5.11 5.11 0 0 1-4.429-2.557h-13.499a2.13 2.13 0 1 1 0-4.26h13.106a5.115 5.115 0 0 1 9.644 0Zm-22.75 11.079a2.13 2.13 0 1 0 0 4.26h3.499a5.113 5.113 0 0 0 8.858 0h20.879a2.13 2.13 0 0 0 0-4.26h-20.485a5.116 5.116 0 0 0-9.645 0h-3.106Zm0 11.078a2.13 2.13 0 1 0 0 4.261h22.499a5.112 5.112 0 0 0 4.429 2.556 5.11 5.11 0 0 0 4.428-2.556h1.88a2.13 2.13 0 0 0 0-4.26h-1.486a5.115 5.115 0 0 0-9.645 0h-22.105Z",
    fill: "#E9E9F6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 212.054,
    y: 3.982,
    width: 37.497,
    height: 4.261,
    rx: 2.131,
    fill: "#C23AA9"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    fill: "url(#f)",
    d: "M212.054 3.982h37.497v4.261h-37.497z"
  }), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 212.054,
    y: 15.06,
    width: 37.497,
    height: 4.261,
    rx: 2.131,
    fill: "#C23AA9"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    fill: "url(#g)",
    d: "M212.054 15.06h37.497v4.261h-37.497z"
  }), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 212.054,
    y: 26.139,
    width: 37.497,
    height: 4.261,
    rx: 2.131,
    fill: "#C23AA9"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    fill: "url(#h)",
    d: "M212.054 26.139h37.497V30.4h-37.497z"
  }), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.113,
    cy: 27.844,
    r: 5.113,
    fill: "#CE45BA"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.113,
    cy: 16.765,
    r: 5.113,
    fill: "#CE45BA"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.113,
    cy: 5.687,
    r: 5.113,
    fill: "#CE45BA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 113.121,
    y1: 33.112,
    x2: 151.428,
    y2: 88.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 147.88,
    y1: 71.712,
    x2: 166.123,
    y2: 71.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.709,
    y1: 81.959,
    x2: 38.206,
    y2: 81.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.709,
    y1: 93.037,
    x2: 38.206,
    y2: 93.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.709,
    y1: 104.115,
    x2: 38.206,
    y2: 104.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 212.054,
    y1: 6.113,
    x2: 249.551,
    y2: 6.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 212.054,
    y1: 17.191,
    x2: 249.551,
    y2: 17.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 212.054,
    y1: 28.269,
    x2: 249.551,
    y2: 28.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroResults);
export default __webpack_public_path__ + "static/media/zeroResults.4145b58a0caa48433dedca0de6f4a3dd.svg";
export { ForwardRef as ReactComponent };